import React from 'react';

// Lê a preferência de modo (Simples/Técnica) persistida no localStorage. Default 'simple' —
// o usuário leigo não deve ver a lista técnica (dezenas de itens auto-criados por estratégia)
// sem pedir. Mesmo padrão do formMode de OrderTemplateModal, só que reutilizável entre telas.
export function getStoredViewMode(storageKey) {
    try {
        return localStorage.getItem(storageKey) || 'simple';
    } catch (_) {
        return 'simple';
    }
}

/**
 * Toggle "Simples ↔ Técnica" reutilizável (Monitores/Automações). Visual igual ao toggle
 * Simples/Avançado dos Modelos de Ordem (btn-group pequeno).
 * props:
 * - mode: 'simple' | 'tech'
 * - onChange: (mode) => void
 * - storageKey: string único por tela (ex: 'monitorsViewMode') — persiste a escolha
 */
function ViewModeToggle({ mode, onChange, storageKey }) {
    function changeMode(next) {
        try { localStorage.setItem(storageKey, next); } catch (_) { /* localStorage indisponível — segue só em memória */ }
        onChange(next);
    }

    return (
        <div className='btn-group btn-group-sm me-2' role='group' aria-label='Modo de visualização' title='Simples esconde itens gerenciados por estratégia; Técnica mostra tudo'>
            <button type='button' className={`btn ${mode === 'simple' ? 'btn-primary' : 'btn-outline-primary'}`} onClick={() => changeMode('simple')}>Simples</button>
            <button type='button' className={`btn ${mode === 'tech' ? 'btn-primary' : 'btn-outline-primary'}`} onClick={() => changeMode('tech')}>Técnica</button>
        </div>
    );
}

export default ViewModeToggle;
